import { Link } from 'react-router-dom'
import { CreditCard, ArrowLeft, Gift, Sparkles } from 'lucide-react'
import CreditBalanceWidget from '@/components/credits/CreditBalanceWidget'

export default function RecruiterCreditsPage() {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-blue-600 font-semibold uppercase tracking-wide">Billing & Usage</p>
          <h1 className="text-2xl font-bold text-gray-900 mt-1">Credits & Usage History</h1>
          <p className="text-gray-600 mt-2 max-w-2xl">
            Track how many credits you have left, where they were used, and add more whenever you need them.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/recruiter/dashboard"
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md hover:bg-gray-50"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Link>
          <Link
            to="/profile"
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-blue-600 rounded-md hover:bg-blue-700"
          >
            <CreditCard className="w-4 h-4 mr-2" />
            Manage Plan
          </Link>
        </div>
      </div>

      <CreditBalanceWidget showHistory className="shadow-sm" />

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-start space-x-3">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-green-500 to-blue-500 flex items-center justify-center text-white">
            <Sparkles className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-900">Need More Credits?</h2>
            <p className="text-gray-600 mt-1">Redeem coupons from your profile or upgrade to a higher plan to keep interviews running smoothly.</p>
            <div className="mt-4 flex flex-wrap gap-3">
              <Link
                to="/profile"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-green-700 bg-green-50 border border-green-200 rounded-md hover:bg-green-100"
              >
                <Gift className="w-4 h-4 mr-2" />
                Redeem Coupon
              </Link>
              <Link
                to="/pricing"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100"
              >
                Explore Plans
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
